import React, { useEffect } from 'react';
import { PageTitle, useSession } from '@cordata/buffet';
import { azureLogout } from '~/utils/ms-ad';

const Logout = ({ history }) => {
  const { logout } = useSession();

  useEffect(() => {
    logout()
      .then(() => {
        localStorage.removeItem('session');
        const azureLogoutSetting = localStorage.getItem('doAzureLogout');
        if (azureLogoutSetting && azureLogoutSetting.toLowerCase() === 'true') {
          localStorage.removeItem('doAzureLogout');
          azureLogout();
        } else {
          history.push('/login');
        }
      });
  }, []);

  return (<>
    <PageTitle>Logging out</PageTitle>
  </>);
};

export default Logout;
